/**
 * A general purpose Table component that displays a list of files
 * with some actions associated with each item
 */

import React from "react";
import SmartTable from "./SmartTable";

interface headCell {
  name?: string | React.ReactElement;
  idFormattedName?: string;
  id: string;
  alignRight?: boolean;
  size?: string;
}
interface ISmartTableProps {
  headCells: headCell[];
  rows: any;
  smartProps?: any;
  editableProps?: any;
  whiteHeader?: boolean;
  verticalOverflow?: boolean;
  aggregate?: {
    removeZeroBalanced?: boolean;
    showZeroBalanced?: boolean;
    required: string[];
    addUp: string[];
  };
  config?: {
    useForStorage?: boolean;
  };
}

const StorageSmartTable: React.FC<ISmartTableProps> = props => {
  return (
      <SmartTable
          {...props}
          config={{
            useForStorage: true
          }}
      />
  );
};

export default StorageSmartTable;
